import axios, { AxiosError, AxiosResponse } from 'axios';

export function setAxiosHeader(header: string, value: string) {
  axios.defaults.headers.common[header] = value;
}

type APIError = AxiosError | AxiosResponse | Error | string | number | object | undefined;

export const isPartialAxiosErrorResponse = (error: APIError): error is AxiosResponse => {
  return (
    error !== undefined &&
    typeof error !== 'string' &&
    typeof error !== 'number' &&
    'status' in error &&
    error.status !== undefined &&
    !!error.config
  );
};

export const isPartialAxiosError = (error: APIError): error is AxiosError => {
  return (
    error !== undefined &&
    typeof error !== 'string' &&
    typeof error !== 'number' &&
    'response' in error &&
    error.response !== undefined &&
    isPartialAxiosErrorResponse(error.response)
  );
};
